"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _polished = require("polished");
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var rotate = (0, _styledComponents.keyframes)(["0%{transform:rotate(90deg)}100%{transform:rotate(449deg)}"]);
var Spinner = _styledComponents.default.span.withConfig({
  displayName: "Spinner",
  componentId: "sc-16xl7n8-0"
})(["display:flex;animation:", " 1.8s infinite cubic-bezier(0.63,0.09,0.32,0.9);border-radius:50%;position:relative;will-change:transform;", ";"], rotate, function (_ref) {
  var theme = _ref.theme,
    size = _ref.size,
    light = _ref.light;
  var spinnerSize = size === 'sm' ? '20px' : theme.space.xxl;
  var borderSize = size === 'sm' ? '3px' : theme.space.xxs;
  var borderColor = light ? theme.colors.ui00 : theme.spinner.color;
  var borderColorLight = (0, _polished.rgba)(borderColor, 0.15);
  return (0, _styledComponents.css)(["height:", ";width:", ";border-top:", " solid ", ";border-right:", " solid ", ";border-bottom:", " solid ", ";border-left:", " solid ", ";"], spinnerSize, spinnerSize, borderSize, borderColorLight, borderSize, borderColorLight, borderSize, borderColorLight, borderSize, borderColor);
});
Spinner.defaultProps = {
  size: 'md',
  light: false
};
var _default = Spinner;
exports.default = _default;